import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { Callout, FontWeights, Text, mergeStyleSets } from '@fluentui/react';
import ChartGauge from './ChartGauge';
import { action_setBoardChartGaugeSelectedDataPoint } from '../../../../../../reducers/actions/KPI/actions';
import { useState } from 'react';

function ChartOriginalMiniNew(props) {
  	const { t } = useTranslation();
  	const dispatch = useDispatch();

  	const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

    //Parametros de entrada.
    const { 
		inputParam_ReportMode = false,
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_ShowGauge = false,
    } = props;

	const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
	const [selectedGaugeDataPointIndex, setSelectedGaugeDataPointIndex] = useState(0);

	const acronim_titles = {
		acronim_s1_real: { acronim: "S1-Real", text: t("data-lang-lbl-field-valueReal")},
		acronim_s1_valueGoalPercent: {acronim: "S1-GoalP", text: t("data-lang-lbl-field-valueGoalPercent")},
		acronim_s1_valueGoal: {acronim: "S1-Goal", text: t("data-lang-lbl-field-valueGoal")},
	}

	const _base = [
		{
			name: acronim_titles.acronim_s1_real.acronim,
			type: "column",
			data: inputParam_ComponentContent.l_vals.map(({ displayValue }) => displayValue)
		},
		{
			name: acronim_titles.acronim_s1_valueGoalPercent.acronim,
			type: "line",
			data: inputParam_ComponentContent.l_vals.map(({ valueGoalPercent }) => valueGoalPercent)
		},
		{
			name: acronim_titles.acronim_s1_valueGoal.acronim,
			type: "line",
			data: inputParam_ComponentContent.l_vals.map(({ valueGoal }) => valueGoal)
		}
	]

  	const listSeriesX = inputParam_ComponentContent ? _base : []

  	const listSerieTimeY = inputParam_ComponentContent.l_vals.map(({ serieTimeStr }) => serieTimeStr)
  
  	const _baseSerieNames = [
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#1F7BE8'
			},
			labels: {
				style: {
				colors: '#1F7BE8',
				}
			},
			tooltip: {
				enabled: true
			},
			title: {
				text: acronim_titles.acronim_s1_real.acronim,
				style: {
				color: '#1F7BE8',
				}
			}
		},
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#000099'
			},
			opposite: true,
			title: {
				text: acronim_titles.acronim_s1_valueGoalPercent.acronim,
				style: {
				color: '#000099',
				}
			}   
		},
		{
			show: false,
			title: {
				text: acronim_titles.acronim_s1_valueGoal.acronim,
				style: {
				color: '#FF8000',
				}
			}
		}
	]

	const title = (boardVariableDataserieValues.find(x => x.dataserieId === inputParam_ComponentContent.dataserieId).variableName);
	const subtitle = (boardVariableDataserieValues.find(x => x.dataserieId === inputParam_ComponentContent.dataserieId).um);

	const chartRef = useRef(null);

	useEffect(() => {
		try {
			if (inputParam_ComponentContent) {
				setTimeout(() => {
					const chart = chartRef.current.chart;
	
					chart.toggleSeries(acronim_titles.acronim_s1_valueGoalPercent.acronim)
					chart.toggleSeries(acronim_titles.acronim_s1_valueGoal.acronim)
				}, "100");
			}
		} catch (error) {
			
		}
    }, [inputParam_ComponentContent]);

	const styles = mergeStyleSets({
		callout: {
			width: 320,
			maxWidth: '90%',
			padding: '20px 24px',
		},
		title: {
		  	marginBottom: 12,
		  	fontWeight: FontWeights.semilight,
		}
	});

	return  <Card className='board-element-form h-100'>
				{
					!inputParam_HideHeader &&
					<Card.Header className="card-header-compact">
						<Card.Title className="d-flex justify-content-between">
                            <b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}</b>
							<div className='toolbar d-flex'>
							</div>
						</Card.Title>
					</Card.Header>
				}
				<Card.Body className='px-2 pt-2'>
				{
						inputParam_ComponentContent ?
						<div className='px-3 h-100 d-flex'>
							{
								inputParam_ShowGauge &&
									<ChartGauge
										inputParam_ComponentContent={inputParam_ComponentContent}
										selectedGaugeDataPointIndex={selectedGaugeDataPointIndex}
									/>
							}
							<Col>
								<ReactApexChart
									ref={chartRef}
									type="line"
									series={ listSeriesX }
									options={{
										title: {
											text: inputParam_ReportMode ? "" : title,
											align: 'center',
										},
										subtitle: {
											text: inputParam_ReportMode ? "" : subtitle,
											align: 'center',
										},
										colors: ['#1F7BE8', '#000099', '#FF8000'],
										chart: {
											height: 350,
											type: 'line',
											stacked: false,
											events: {
												dataPointSelection: (event, chartContext, config) => { 
													setTimeout(() => {
														//dispatch(action_setBoardChartGaugeSelectedDataPoint(config.dataPointIndex))
														setSelectedGaugeDataPointIndex(config.dataPointIndex);
													}, 10);
												}
											},
											toolbar: {
												tools: {
													customIcons: [{
														icon: `<i class="ms-Icon ms-Icon--FileComment" aria-hidden="true"></i>`,
														index: -1,
														title: t('data-lang-lbl-charttooltiplegend'),
														class: 'custom-legeng-chart',
														click: toggleIsCalloutVisible
													}]
												}
											}
										},
										dataLabels: {
											enabled: false
										},
										stroke: {
											width: [2, 2, 2],
											dashArray: [0, 0, 5]
										},
										xaxis: {
											categories: listSerieTimeY,
										},
										yaxis: _baseSerieNames,
										tooltip: {
											fixed: {
											enabled: true,
											position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
											offsetY: 30,
											offsetX: 60
											},
										},
										legend: {
											horizontalAlign: 'center',
											offsetX: 40
										},
										responsive: [{
											breakpoint: undefined,
											options: {},
										}]
									}}
									height={"100%"}
								/>
								{isCalloutVisible &&
									<Callout
										role="dialog"
										gapSpace={0}
										target={`.custom-legeng-chart`}
										onDismiss={toggleIsCalloutVisible}
										setInitialFocus
										className={styles.callout}
									>
										<Text as="h1" block variant="xLarge"> { t('data-lang-lbl-chartlegend') } </Text>
										<Text className='pb-2' block variant="small">
											<Row>
												<Col className='col-auto'>
													<b>{`${acronim_titles.acronim_s1_real.acronim}:`}</b> {`${acronim_titles.acronim_s1_real.text}`}
												</Col>
											</Row>
											<Row>
												<Col className='col-auto'>
													<b>{`${acronim_titles.acronim_s1_valueGoal.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoal.text}`}
												</Col>
											</Row>
											<Row>
												<Col className='col-auto'>
													<b>{`${acronim_titles.acronim_s1_valueGoalPercent.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoalPercent.text}`}
												</Col>
											</Row>
										</Text>
									</Callout>
								}
							</Col>
						</div>
						: <NoDataLayer display={ true } />
					}
				</Card.Body>
			</Card>
}

ChartOriginalMiniNew.propTypes = {
  	inputParam_BoardId: PropTypes.number.isRequired,
  	inputParam_Height: PropTypes.number,
  	inputParam_ReportMode: PropTypes.bool,
};

export default ChartOriginalMiniNew;